// extracted by css-extract-rspack-plugin
export default {"bodyText":"_b042e478","videoWrapper":"_72fbd937","caption":"_70d15f9b","videoCaption":"_41ab28a","iframeWrapper":"_1a1de2b2"};